import * as Yup from "yup";

const numField = (label) =>
  Yup.number()
    .transform((v, ov) => (String(ov).trim() === "" ? undefined : v))
    .typeError(`${label} must be a number`)
    .required(`${label} is required`)
    .min(0, `${label} cannot be negative`);

export const studentStatisticsSchema = Yup.object().shape({
  institution_id: Yup.string().required("Institution is required"),
  session_id: Yup.string().required("Year is required"),
  student_category_stats: Yup.array().of(
    Yup.object().shape({
      student_category_id: Yup.string().required(
        "Student Category is required"
      ),

      // Humanities
      number_of_males: numField("Humanities Male Count"),
      number_of_females: numField("Humanities Female Count"),

      // Sciences
      sciences_number_of_males: numField("Sciences Male Count"),
      sciences_number_of_females: numField("Sciences Female Count"),

      // Optional: make this required if you want it mandatory
      number_of_students_with_special_needs: numField("Special Needs Count"),
    })
  ),
});
